import React from 'react'
import { Card, Box, Typography } from '@material-ui/core'
import CouponBackgroundSVG from '../shared/svgs/CouponBackgroundSVG'
import { useSherwinCouponCardStyles } from './useSherwinCouponCardStyles'
import sherwinWilliamsLogoImage from 'src/public/images/sherwin-williams-logo.png'

export default function SherwinCouponCard() {
  const classes = useSherwinCouponCardStyles()

  return (
    <div className={classes.couponContainer}>
      <div className={classes.couponBackground}>
        <CouponBackgroundSVG />
      </div>
      <Card className={classes.couponCard}>
        <div className={classes.sherwinLogo}>
          <img src={sherwinWilliamsLogoImage} alt="Sherwin-Williams" className={classes.logoImage} />
        </div>
        <Box className={classes.couponContent}>
          <Typography className={classes.couponAmount}>$100</Typography>
          <Typography className={classes.couponLabel}>Coupon</Typography>
        </Box>
      </Card>
    </div>
  )
}
